<svg:svg [attr.viewBox]="viewBox">
    <defs>
        <filter id="shadow">
            <feDropShadow dx="0.5" dy="0.5" stdDeviation="3" />
        </filter>
    </defs>
    <svg:g [style.transform]="transform">
        <ng-content></ng-content>
        <svg:g aaTitle [title]="title" [dimensions]="dimensions"></svg:g>
    </svg:g>
</svg:svg>
